import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { FirebaseProvider } from "api/FirebaseProvider";
import { StateProvider } from "AppStore";
import TouchLayout from "components/touchLayout/TouchLayout";
import TagTesting from "components/utility/TagTesting";

export type ScreenState =
  | "Dashboard"
  | "Dashboard-Top"
  | "Frontpage"
  | "Transition-To-Dash"
  | "Transition-To-FP"
  | "Frontpage-preview";

const App = () => {
  return (
    <FirebaseProvider>
      <StateProvider>
        <BrowserRouter>
          <Switch>
            <Route path="/display/:site/test-tag" component={TagTesting} />
            <Route path="/display/:site?" component={TouchLayout} />
            <Route path="/:site?" component={TouchLayout} />
          </Switch>
        </BrowserRouter>
      </StateProvider>
    </FirebaseProvider>
  );
};

export default App;
